var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.283783,
    y: 0.378418,
    width: 25.5405,
    height: 25.5405,
    rx: 12.7703,
    fill: "#9A291B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3686 11.246L14.956 11.8334L9.17109 17.6183H8.58366V17.0309L14.3686 11.246ZM16.6672 7.4021C16.5076 7.4021 16.3416 7.46595 16.2203 7.58727L15.0518 8.75575L17.4462 11.1502L18.6147 9.98169C18.8637 9.73267 18.8637 9.33041 18.6147 9.08139L17.1206 7.58727C16.9929 7.45957 16.8333 7.4021 16.6672 7.4021ZM14.3686 9.43896L7.30663 16.5009V18.8953H9.70106L16.763 11.8334L14.3686 9.43896Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5e50ccc8af3c9f83d494266826a4362f.svg";
export { ForwardRef as ReactComponent };